export type ServiceType = 'Labor' | 'Rate Card' | 'Vendor' | 'Fixed' | 'Custom';
export const SERVICE_TYPES: ServiceType[] = ['Labor', 'Rate Card', 'Vendor', 'Fixed', 'Custom'];

export interface BidProjectType { id: string; name: string; }

export interface CatalogService {
  id: string;
  name: string;
  type: ServiceType;
  fixedRate: number | null;
  hourlyRate: number | null;
  markup: number;
  pts: string[];
  rateCardId?: string;
}

export interface TemplateRow {
  id: string;
  projectTypeId: string;
  projectTypeName: string;
  name: string;
  type: ServiceType;
  fixedRate: number | null;
  hourlyRate: number | null;
  hours: number | null;
  markup: number;
  defaultOn: boolean;
  rateCardId?: string;
  /** True when this template was removed from the project type but a bid still references it. */
  deleted?: boolean;
}

/** `description` explains what work the tier covers, shown on an info tooltip where the tier is
 *  picked. Optional: it is set in admin per tier, and tiers without one fall back to a seeded
 *  default. */
export interface RcTier  { id: string; name: string; rate: number; description?: string; }
export interface RcAddon { id: string; name: string; price: number; }

export interface RateCard {
  id: string;
  name: string;
  type: string;
  tiers: RcTier[];
  addons: RcAddon[];
}
